import React from 'react';
import {
  NotificationType,
  NotificationRenderFunction,
  NotificationQueueItem,
} from '../redux/types';
import { useCustomNotifications } from '../CustomNotificationContext';
import CustomNotification from '../CustomNotification';
import type {
  OffsetModifier,
  PositioningProps,
} from '@wix/da-ds/pkg/popper/types';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';

const offsetModifier: OffsetModifier = [0, 8];

export interface Props extends PositioningProps {
  notificationTypes?: (string | NotificationType)[];
  className?: string;
  contentClassName?: string;
  notificationFilter?: (notification: NotificationQueueItem) => boolean;
  customNotificationRender?: NotificationRenderFunction;
}

const PopoverNotification: React.FC<React.PropsWithChildren<Props>> = ({
  notificationTypes,
  className,
  contentClassName,
  customNotificationRender,
  notificationFilter,
  children,
  isVisible,
  placement = 'top',
  secondaryPlacement = 'start',
}) => {
  const { notifications } = useCustomNotifications(notificationTypes);
  const hasNotification =
    !!notificationTypes &&
    (!notificationFilter || notifications.some(notificationFilter));

  return (
    <SimplePopperPopover
      isVisible={hasNotification && isVisible}
      showArrow
      placement={placement}
      secondaryPlacement={secondaryPlacement}
      offsetModifier={offsetModifier}
      className={className}
      contentClassName={contentClassName}
      popoverContent={
        <CustomNotification
          notificationTypes={notificationTypes}
          customNotificationRender={customNotificationRender}
          notificationFilter={notificationFilter}
        />
      }
    >
      {children}
    </SimplePopperPopover>
  );
};
PopoverNotification.displayName = 'PopoverNotification';

export default PopoverNotification;
